import request from '@/common/request'
import { Cadastro, ContaResponse } from '@/models'

export const signUpAccount = (data: Cadastro): Promise<ContaResponse> => 
	request.post(`/contas`, data)